import { T } from '../lib/tokens'
import { useTags } from '../lib/hooks'
import { supabase } from '../lib/supabase'
import { useQuery } from '@tanstack/react-query'
import { Sidebar } from '../components/Sidebar'
import { Topbar } from '../components/Topbar'
import { LoadingSpinner } from '../components/ui'

export function TagsPage() {
  const { data: tags = [], isLoading } = useTags()

  // タグ別アイテム数
  const { data: tagCounts = {} } = useQuery<Record<string,number>>({
    queryKey: ['tag-counts'],
    queryFn: async () => {
      const { data } = await supabase
        .from('ml_item_tags').select('tag_id')
      const counts: Record<string,number> = {}
      for (const row of data??[]) {
        counts[row.tag_id] = (counts[row.tag_id]??0)+1
      }
      return counts
    },
    staleTime: 1000*60,
  })

  const maxCount = Math.max(...Object.values(tagCounts), 1)

  const sortedTags = [...tags].sort((a,b)=>(tagCounts[b.id]??0)-(tagCounts[a.id]??0))

  return (
    <div style={{ display:'flex',height:'100dvh',background:T.bg,color:T.text,fontFamily:T.font,overflow:'hidden' }}>
      <Sidebar />
      <div style={{ flex:1,display:'flex',flexDirection:'column',overflow:'hidden' }}>
        <Topbar />
        <main style={{ flex:1,overflowY:'auto',padding:'28px 28px 40px' }}>
          <div style={{ display:'flex',alignItems:'baseline',gap:12,marginBottom:24 }}>
            <h2 style={{ fontSize:18,fontWeight:700,color:T.text,margin:0 }}>タグ</h2>
            <span style={{ fontSize:11,fontFamily:T.fontMono,color:T.textMute }}>{tags.length} 種類</span>
          </div>

          {isLoading && <LoadingSpinner />}

          {!isLoading && tags.length === 0 && (
            <div style={{ padding:'60px 0',textAlign:'center',color:T.textMute,fontSize:13 }}>
              まだタグがありません
            </div>
          )}

          {/* タグクラウド */}
          <div style={{ display:'flex',flexWrap:'wrap',gap:8,marginBottom:40 }}>
            {sortedTags.map(tag => {
              const count = tagCounts[tag.id] ?? 0
              const ratio = count / maxCount
              const size = 11 + ratio * 10  // 11px〜21px
              const opacity = 0.45 + ratio * 0.55
              return (
                <button key={tag.id} style={{
                  padding:'4px 10px',borderRadius:5,cursor:'pointer',
                  background:T.bgRaised,border:`1px solid ${T.border}`,
                  color:T.textDim,fontSize:size,fontFamily:T.fontMono,
                  opacity, transition:'all 0.12s',
                }}
                  onMouseEnter={e=>{(e.currentTarget as HTMLElement).style.borderColor=T.borderHi;(e.currentTarget as HTMLElement).style.color=T.text}}
                  onMouseLeave={e=>{(e.currentTarget as HTMLElement).style.borderColor=T.border;(e.currentTarget as HTMLElement).style.color=T.textDim}}
                >
                  #{tag.name}
                  {count>0&&<span style={{ fontSize:9,color:T.textMute,marginLeft:5,fontFamily:T.fontMono }}>{count}</span>}
                </button>
              )
            })}
          </div>

          {/* リスト表示 */}
          {sortedTags.length > 0 && (
            <div>
              <div style={{ fontSize:11,fontFamily:T.fontMono,color:T.textMute,letterSpacing:'0.12em',marginBottom:12 }}>
                ALL TAGS
              </div>
              <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:6 }}>
                {sortedTags.map(tag=>(
                  <div key={tag.id} style={{ display:'flex',alignItems:'center',gap:8,padding:'7px 10px',background:T.bgRaised,border:`1px solid ${T.border}`,borderRadius:6 }}>
                    <span style={{ fontSize:12,fontFamily:T.fontMono,color:T.textDim,flex:1 }}>#{tag.name}</span>
                    <span style={{ fontSize:10,fontFamily:T.fontMono,color:T.textMute }}>{tagCounts[tag.id]??0}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  )
}
